export default {
    root: {
        class: [
            'tw-block tw-relative tw-text-sm',
            // Base Label Appearance
            '[&>*:last-child]:tw-text-gray-900/60 dark:[&>*:last-child]:tw-text-white/60',
            '[&>*:last-child]:tw-bg-white [&>*:last-child]:tw-px-1',
            '[&>*:last-child]:tw-absolute',
            '[&>*:last-child]:tw-left-3',
            // // Position for all labels except those following textarea
            // '[&>:not(textarea)~label]:tw-top-1/2 [&>:not(textarea)~label]:tw--translate-y-1/2 ',
            //
            // // Position for labels following textareas
            // '[&>textarea~label]:tw-top-4',
            '[&>*:last-child]:tw-tw-left-3',
            '[&>*:last-child]:tw-tw-pointer-events-none',
            '[&>*:last-child]:tw-tw-transition-all',
            '[&>*:last-child]:tw-tw-duration-200',
            '[&>*:last-child]:tw-tw-ease',
            '[&>*:last-child]:tw--top-2',
            '[&>*:last-child]:tw-text-sm',
            '[&>*:last-child]:tw-z-10',
            // Focus Label Appearance
            // Zatim na to nemame usecase takze neresim
            // '[&>*:last-child]:has-[:focus]:tw--top-3',
            // '[&>*:last-child]:has-[:focus]:tw-text-sm',
            // '[&>*:last-child]:has-[:focus]:tw-z-10',
            // Filled Input Label Appearance
            // Toto nam klasicky nikdy nebude fungovat když v TW nebude class .filled, ale zatim na to nemame usecase takze neresim
            // '[&>*:last-child]:has-[.filled]:tw--top-3',
            // '[&>*:last-child]:has-[.filled]:tw-text-sm',
            // '[&>*:last-child]:has-[.filled]:tw-z-10',
        ],
    },
};
